import AxiosAPI from '../../utils/AxiosAPI';

// operation for send email
export const handleSendEmailOpe = (setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-security/enable-2fa`)
            .post()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for submit otp
export const handleSubmitOtpOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-security/enable-2fa`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for disable two factor authentication
export const handleDisable2faOpe = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-security/disable-2fa`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for change password
export const handleChangePasswordOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-security/change-password`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
